import { Anchor, AnchorProps } from '@mantine/core';
import classes from './PhoneNumberAnchor.module.css';

type PhoneNumberAnchorPropsType = {
  phoneNumber: string;
} & AnchorProps;

export const PhoneNumberAnchor: React.FC<PhoneNumberAnchorPropsType> = ({
  phoneNumber,
  ...props
}) => {
  return (
    <Anchor className={classes.anchor} href={`tel:${phoneNumber}`} {...props}>
      {phoneNumber}
    </Anchor>
  );
};
